import React from 'react';

// Menu items for all users (admin and regular users)
export const MenuList = [
    // Stream Dashboard - Main page for all users
    {
        title: 'Stream Dashboard',
        iconStyle: <i className="fas fa-tachometer-alt" aria-hidden="true"></i>,
        to: 'stream-dashboard',
    },
    
    // Create Stream - Standalone page
    {
        title: 'Create Stream',
        iconStyle: <i className="fas fa-video" aria-hidden="true"></i>,
        to: 'create-stream',
    },
    
    // All Streams - Standalone page
    {
        title: 'All Streams',
        iconStyle: <i className="fas fa-list" aria-hidden="true"></i>,
        to: 'streams',
    },
    
    // VOD Management - With submenu
    {
        title: 'VOD Management',
        iconStyle: <i className="fas fa-film" aria-hidden="true"></i>,
        to: '#',

        content: [
            {
                title: 'Media Directories',
                to: 'vod/directories',
            },
            {
                title: 'VOD Uploader',
                to: 'vod/uploader',
            },
            {
                title: 'Playlists',
                to: 'vod/playlists',
            },
            {
                title: 'Schedules',
                to: 'vod/schedules',
            },
        ],
    },

];


// Admin-only menu items
export const AdminMenuList = [
    // User Management - Admin only
    {
        title: 'User Management',
        iconStyle: <i className="fas fa-users" aria-hidden="true"></i>,
        to: 'admin/users',
    },
    
    // Role Management - Admin only
    {
        title: 'Role Management',
        iconStyle: <i className="fas fa-shield-alt" aria-hidden="true"></i>,
        to: 'admin/roles',
    },
    
    // General Settings - Admin only
    {
        title: 'General Settings',
        iconStyle: <i className="fas fa-cog" aria-hidden="true"></i>,
        to: 'admin/settings',
    },
];

// Helper function to get menu based on user role
export const getMenuByRole = (role) => {
    if (role === 'admin') {
        return [...MenuList, ...AdminMenuList];
    }
    return MenuList;
};
